import React from 'react'
import { useKhmdjhyUpdateMutation } from '../../store/BnsKeJiApi'
import { App } from 'antd'
function ContactAddFriend(props) {
    const {message} = App.useApp()
    const [khmdjhyAdd] = useKhmdjhyUpdateMutation()
    return (
        <a onClick={() => {
            if(props.gzwx_id==='' || props.gzwx_id === null || props.gzwx_id === undefined){
                message.error('请选择工作微信！')
                return
            }
            khmdjhyAdd({
                'khmd_id': props.khmd_id,
                'khmd_gzwx_id': props.gzwx_id,
                'khmd_gzwx_name': props.gzwx_name,
                'khmd_gzwx_phone': props.gzwx_phone,
                'khmd_gzwx_uid': props.eu_id,
                'khmd_gzwx_uname': props.eu_name
            }).then((res) => {
                if(res.data.Status==='success'){
                    message.success('加好友成功！')
                }else{
                    message.error('加好友失败！'+res.data.Message)
                }
            })
        }}>已加</a>
    )
}

export default ContactAddFriend